import { lazy } from 'react';
import RegionForm from './RegionForm';
import RegionList from './RegionsList';

const RegionConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/regions',
            element: <RegionList />,
        },
        {
            path: '/addRegion',
            element: <RegionForm />,
        },
        {
            path: '/editRegion/:id',
            element: <RegionForm />,
        },
    ],
};

export default RegionConfig;
